<template>
  <div class="inquiryDetail contentsWidth mx-auto mt-4">
    <div class="contentsWidth mx-auto mt-4">

      <div class="subject">
        <p class="title mb-0">問合せ履歴 - 詳細</p>
        <hr class="title">
      </div>

      <!-- 問合せ者情報（変更不可） -->
      <div class="infoArea p-3 mb-3">
        <b-row class="mx-0">
          <div class="infoLabel bold">タイトル</div>
          <div class="infoValue">{{ inquiry.title }}</div>
        </b-row>
        <b-row class="mx-0">
          <div class="infoLabel bold">氏名</div>
          <div class="infoValue">{{ inquiry.applicant_name }}</div>
        </b-row>
        <b-row class="mx-0">
          <div class="infoLabel bold">メールアドレス</div>
          <div class="infoValue">{{ inquiry.applicant_mail }}</div>
        </b-row>
        <!-- No.9 Phase C：氏名・メールは「投稿した人」なので、代行者の投稿を含む
             スレッドでは誰の件か分からない。持ち主（採択者）を明示する。 -->
        <b-row v-if="inquiry.has_agent_message" class="mx-0">
          <div class="infoLabel bold">代行対象</div>
          <div class="infoValue">{{ inquiry.principal_name || '(不明)' }}</div>
        </b-row>
      </div>

      <!-- スレッド：上(古い)→下(新しい) -->
      <div
        v-for="(m, i) in inquiry.messages" :key="i"
        :class="['msg', 'p-3', 'mb-3', isCms(m) ? 'msgCms' : 'msgGas']">
        <div class="flex flexMiddle mb-2">
          <span class="bold mr-2">{{ senderName(m) }}</span>
          <span v-if="!isCms(m) && m.sender_category" :class="['categoryBadge', 'mr-2', categoryClass(m.sender_category)]">{{ categoryText(m.sender_category) }}</span>
          <span class="msgDate">{{ formatDate(m.created_at) }}</span>
        </div>
        <div class="msgBody">{{ m.body }}</div>
        <div v-if="m.files && m.files.length" class="mt-2">
          <p v-for="(f, fi) in m.files" :key="fi" class="mb-0">
            <b-link @click="downloadFile(f)">{{ f.file_name }}</b-link>
          </p>
        </div>
      </div>

      <!-- 回答（インライン入力） -->
      <div v-if="showInput" class="inputArea p-3 mt-3">
        <div class="bold mb-2"><span class="mr-2 badge badge-required">必須</span>回答</div>
        <b-form-textarea v-model="body" :rows="5" maxlength="10000" placeholder="入力してください。" class="mb-2"/>
        <p v-for="(f, i) in fileList" :key="i" class="mb-1">
          {{ f.name }}
          <img src="@/assets/svg/close_small.svg" class="tdDeleteBtn" @click="removeFile(i)">
        </p>
        <div
          @dragover.prevent="toggleDrag(true)"
          @dragleave.prevent="toggleDrag(false)"
          @drop.prevent="onDrop($event)"
          :class="[isDragging ? 'is-dragging' : '', 'drop', 'flex', 'flexMiddle', 'flexCenter']">
          <span>
            <span class="dragText fw-6">ここにファイルをドラッグ＆ドロップ または</span>
            <label class="fileText fw-6 selectFile">［ ファイルを選択 ］
              <input type="file" style="display:none;" @change="addFile">
            </label>
          </span>
        </div>
        <div class="mt-3 flex flexCenter">
          <b-button
            variant="primary"
            class="btn btn-primary btn-lg bold"
            :disabled="sending"
            @click="send">送信</b-button>
        </div>
      </div>

      <div class="mt-5 mb-4 flex flexCenter">
        <b-button class="btn btn-lg back bold mr-3" @click="goList">一覧に戻る</b-button>
        <b-button
          v-if="!showInput"
          variant="primary"
          class="btn btn-primary btn-lg bold"
          @click="showInput = true">回答</b-button>
      </div>

    </div>
  </div>
</template>

<script>
import api from '@/modules/api';
import moment from 'moment';
import download from '@/modules/download';
import INQUIRY from '@/constants/inquiryStatus';

export default {
  name: 'cmsInquiriesDetail',
  data() {
    return {
      showInput: false,
      body: '',
      fileList: [],
      isDragging: false,
      sending: false,
      inquiry: {
        id: null,
        title: '',
        applicant_name: '',
        applicant_mail: '',
        messages: [],
      },
    };
  },
  async created() {
    await this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      const { id } = this.$route.query;
      if (!id) {
        this.$router.push({ name: 'cmsInquiriesList' });
        return;
      }
      try {
        const res = await api.send('/api/cms/inquiries/detail', { inquiryId: id });
        this.inquiry = res.data.inquiry;
      } catch (e) {
        this.$bvModal.msgBoxOk('問合せの取得に失敗しました。');
        this.$router.push({ name: 'cmsInquiriesList' });
      }
    },
    isCms(m) {
      return m.sender_type === 2;
    },
    senderName(m) {
      return this.isCms(m) ? '事務局' : this.inquiry.applicant_name;
    },
    categoryText(category) {
      return INQUIRY.INQUIRY_SENDER_CATEGORY_TEXTS[category] || '';
    },
    categoryClass(category) {
      // No.9 (B)：代行者の投稿を判別できるよう色を分ける（回答に何を書くかの判断に直結する）
      if (category === INQUIRY.INQUIRY_SENDER_CATEGORY.AGENT) {
        return 'cat-agent';
      }
      return category === INQUIRY.INQUIRY_SENDER_CATEGORY.ADOPTEE ? 'cat-adoptee' : 'cat-applicant';
    },
    formatDate(dt) {
      return dt ? moment(dt).format('YYYY/MM/DD HH:mm') : '';
    },
    async downloadFile(f) {
      try {
        const res = await api.send('/api/cms/inquiries/download', { fileId: f.id }, true);
        download.blob(res.data, f.file_name);
      } catch (e) {
        this.$bvModal.msgBoxOk('ファイルのダウンロードに失敗しました。');
      }
    },
    addFile(event) {
      if (event.target.files.length === 0) {
        return;
      }
      const input = event.target;
      this.fileList.push(input.files[0]);
      input.value = '';
    },
    toggleDrag(isDragging) {
      this.isDragging = isDragging;
    },
    onDrop(event) {
      this.isDragging = false;
      const { files } = event.dataTransfer;
      if (!files || files.length === 0) {
        return;
      }
      Object.keys(files).forEach((key) => {
        this.fileList.push(files[key]);
      });
    },
    removeFile(index) {
      this.fileList.splice(index, 1);
    },
    goList() {
      this.$router.push({ name: 'cmsInquiriesList' });
    },
    async send() {
      if (this.sending) {
        return;
      }
      if (!this.body) {
        this.$bvModal.msgBoxOk('本文を入力してください。');
        return;
      }
      if (!(await this.confirm('現在の内容で回答してよろしいですか？'))) {
        return;
      }
      this.sending = true;
      const params = {
        inquiryId: this.inquiry.id,
        body: this.body,
        fileCnt: this.fileList.length,
      };
      this.fileList.forEach((file, i) => {
        params[`file_${i}`] = file;
      });
      try {
        await api.sendForm('/api/cms/inquiries/reply', params);
        this.showInput = false;
        this.body = '';
        this.fileList = [];
        await this.fetchDetail();
        this.sending = false;
      } catch (e) {
        this.$bvModal.msgBoxOk('送信に失敗しました。');
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
  .infoArea {
    background-color: #F3F3F3;
    border-radius: 6px;
  }
  .infoLabel {
    width: 160px;
  }
  .infoValue {
    width: 760px;
  }
  .msg {
    border: solid 1px #CCC;
    border-radius: 6px;
  }
  .msgGas {
    background-color: #fff;
  }
  .msgCms {
    background-color: #EEF3FB;
  }
  .msgDate {
    color: #888;
    font-size: 13px;
  }
  .categoryBadge {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 10px;
    font-size: 12px;
  }
  .categoryBadge.cat-applicant {
    background-color: #EAF1FB;
    color: #2F5597;
  }
  .categoryBadge.cat-agent {
  background: #E3F3E1;
  color: #2C6B2F;
  border: 1px solid #BCDCB8;
}
.cat-adoptee {
    background-color: #FBEBD9;
    color: #B9651B;
  }
  .msgBody {
    white-space: pre-wrap;
  }
  .inputArea {
    background-color: #fff;
    border: solid 1px #A0A9D0;
    border-radius: 6px;
  }
  .drop {
    height: 100px;
    width: 100%;
    background-color: #F3F3F3;
    border-color: #CCC;
    border-style: dashed;
    border-radius: 10px;
    border-width: 1px;
  }
  .is-dragging.drop {
    background-color: #E6E6E6;
    border-color: #6E6E6E;
  }
  .dragText {
    color: #BBB;
  }
  .fileText {
    color: #0A8EA7;
    cursor: pointer;
  }
  .selectFile:hover {
    text-decoration: underline;
  }
</style>
